import { render } from "./TeamView.vue?vue&type=template&id=e7ed4b5c&scoped=true&ts=true"
import script from "./TeamView.vue?vue&type=script&lang=ts"
export * from "./TeamView.vue?vue&type=script&lang=ts"

import "./TeamView.vue?vue&type=style&index=0&id=e7ed4b5c&scoped=true&lang=css"

import exportComponent from "/Users/tomasfic/Projects/osobni/kometa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7ed4b5c"]])

export default __exports__